import {
  REQUEST_NEW_ACTIVITY,
  RECEIVE_NEW_ACTIVITY,
  FAILURE_NEW_ACTIVITY,
  REQUEST_DELETE_ACTIVITY,
  RECEIVE_DELETE_ACTIVITY,
  FAILURE_DELETE_ACTIVITY,
  REQUEST_ACTIVITIES,
  RECEIVE_ACTIVITIES,
  FAILURE_ACTIVITIES,
  SET_SELECTED_ACTIVITY,
  REQUEST_TAGS,
  RECEIVE_TAGS,
  FAILURE_TAGS,
  REQUEST_CATEGORY,
  RECEIVE_CATEGORY,
  FAILURE_CATEGORY,
  REQUEST_UPDATE_ACTIVITY,
  RECEIVE_UPDATE_ACTIVITY,
  FAILURE_UPDATE_ACTIVITY,
  REQUEST_DELETE_ASSET,
  RECEIVE_DELETE_ASSET,
  FAILURE_DELETE_ASSET,
  REQUEST_DELETE_COMMENTS,
  RECEIVE_DELETE_COMMENTS,
  START_DELETE_COMMENTS,
  REQUEST_ACTIVITY,
  EDIT_ACTIVITY,
  FAILURE_ACTIVITY,
  REQUEST_UPDATE_ENHANCED_ACTIVITY,
  FAILURE_UPDATE_ENHANCED_ACTIVITY,
} from '../constants/actionTypes';

export function reqNewActivity(activity, asset, enhanced = false) {
  return {
    type: REQUEST_NEW_ACTIVITY,
    payload: activity,
    asset,
    enhanced
  };
}

export function receiveNewActivity(activity) {
  return {
    type: RECEIVE_NEW_ACTIVITY,
    payload: activity,
  };
}

export function failureNewActivity() {
  return {
    type: FAILURE_NEW_ACTIVITY,
  };
}

export function requestDeleteActivity(activity, meta) {
  return {
    type: REQUEST_DELETE_ACTIVITY,
    payload: activity,
    meta,
  };
}

export function receiveDeleteActivity(activity) {
  return {
    type: RECEIVE_DELETE_ACTIVITY,
    payload: activity,
  };
}

export function failureDeleteActivity(error) {
  return {
    type: FAILURE_DELETE_ACTIVITY,
    payload: error,
  };
}

export function reqActivities(fieldUUID) {
  return {
    type: REQUEST_ACTIVITIES,
    fieldUUID,
  };
}

export function receiveActivities(activities) {
  return {
    type: RECEIVE_ACTIVITIES,
    payload: activities,
  };
}

export function failureActivities() {
  return {
    type: FAILURE_ACTIVITIES,
  };
}

export function setSelectedActivity(index, id) {
  return {
    type: SET_SELECTED_ACTIVITY,
    index,
    id,
  };
}

export function reqTags() {
  return {
    type: REQUEST_TAGS,
  };
}

export function receiveTags(tags) {
  return {
    type: RECEIVE_TAGS,
    payload: tags,
  };
}

export function failureTags() {
  return {
    type: FAILURE_TAGS,
  };
}

export function reqCategories() {
  return {
    type: REQUEST_CATEGORY,
  };
}

export function receiveCategories(categories) {
  return {
    type: RECEIVE_CATEGORY,
    payload: categories,
  };
}

export function failureCategories() {
  return {
    type: FAILURE_CATEGORY,
  };
}

export function reqUpdateActivity(activity, comment, assets, permanent, isNewComment) {
  return {
    type: REQUEST_UPDATE_ACTIVITY,
    payload: { activity, comment, assets, permanent, isNewComment },
  };
}

export function reqUpdateEnhancedActivity(activity, comment, assets, permanent) {
  return {
    type: REQUEST_UPDATE_ENHANCED_ACTIVITY,
    payload: { activity, comment, assets, permanent },
  };
}

export function failureUpdateEnhancedActivity() {
  return {
    type: FAILURE_UPDATE_ENHANCED_ACTIVITY
  };
}

export function receiveUpdateActivity(activity, permanent) {
  return {
    type: RECEIVE_UPDATE_ACTIVITY,
    payload: { activity, permanent },
  };
}

export function failureUpdateActivity() {
  return {
    type: FAILURE_UPDATE_ACTIVITY,
  };
}

export function reqDeleteAsset(activity) {
  return {
    type: REQUEST_DELETE_ASSET,
    payload: activity,
  };
}

export function receiveDeleteAsset() {
  return {
    type: RECEIVE_DELETE_ASSET,
  };
}

export function failureDeleteAsset(error) {
  return {
    type: FAILURE_DELETE_ASSET,
    payload: error,
  };
}

export function reqDeleteComments(activityId, commentsIds, index) {
  return {
    type: REQUEST_DELETE_COMMENTS,
    payload: {
      activityId, commentsIds, index
    }
  };
}

export function startDeleteComments() {
  return {
    type: START_DELETE_COMMENTS
  };
}

export function receiveDeleteComments() {
  return {
    type: RECEIVE_DELETE_COMMENTS
  };
}

export function requestActivity(activityId) {
  return {
    type: REQUEST_ACTIVITY,
    payload: { activityId }
  };
}

export function editActivity(activity) {
  return {
    type: EDIT_ACTIVITY,
    payload: { activity }
  };
}

export function failureActivity() {
  return {
    type: FAILURE_ACTIVITY
  };
}
